<template>
  <div>
    <!-- 顶部显示 -->
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:10px"
    >
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 新增按钮 -->
    <div style="margin-bottom:15px">
      <el-button
        type="primary"
        @click="newlyAdded"
      >添加用户</el-button>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column
        prop="admin"
        label="用户名称"
      >
      </el-table-column>
      <el-table-column
        prop="area_name"
        label="景区名称"
      >
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
          >修改</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 弹框 -->
    <el-dialog
      title="添加用户"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="用户名称"
          prop="name"
        >
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item
          label="设置密码"
          prop="password"
        >
          <el-input
            type="password"
            v-model="ruleForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="景区选择"
          prop="region"
        >
          <el-select
            v-model="ruleForm.region"
            placeholder="请选择景区"
            @change="radioList"
          >
            <el-option
              v-for="item in scenicSpotList"
              :label="item.name"
              :value="item.ids"
            ></el-option>
          </el-select>
          <!-- 景区多选的可能 -->
          <!-- <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="item in scenicSpotList"
              :label="item.name"
              @change="checkBox"
            ></el-checkbox>
          </el-checkbox-group> -->
          <!-- <el-table
            :data="scenicSpotList"
            style="width: 100%"
            height="300"
            @selection-change="choice"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="景区名称"
            >
            </el-table-column>

          </el-table> -->
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >立即添加</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 修改按钮的弹框 -->
    <el-dialog
      title="账号修改"
      :visible.sync="editdialogVisible"
      :rules="rules"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="editInfo"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="用户名称"
          prop="name"
        >
          <el-input v-model="editInfo.admin"></el-input>
        </el-form-item>
        <el-form-item
          label="景区选择"
          prop="region"
        >
          <el-select
            v-model="editInfo.region"
            placeholder="请选择景区"
            @change="radioList"
          >
            <el-option
              v-for="item in scenicSpotList"
              :label="item.name"
              :value="item.ids"
            ></el-option>
          </el-select>
          <!-- 景区多选的可能 -->
          <!-- <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="item in scenicSpotList"
              :label="item.name"
              @change="checkBox"
            ></el-checkbox>
          </el-checkbox-group> -->
          <!-- <el-table
            :data="scenicSpotList"
            style="width: 100%"
            height="300"
            @selection-change="choice"
          >
            <el-table-column
              type="selection"
              width="55"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="景区名称"
            >
            </el-table-column>
          </el-table> -->
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitFormedit('editInfo')"
          >立即修改</el-button>
          <el-button @click="resetFormedit('editInfo')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total,  prev, pager, next, jumper"
        :total="total"
        style="text-align:right;margin:0 16px 10px 0;border-radius:20px"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    pageSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      // 弹框显示与否
      dialogVisible: false,
      // 修改按钮的弹框与否
      editdialogVisible: false,
      // 修改弹框的表单
      editInfo: [],
      // 弹框---表单
      ruleForm: {
        name: '',
        password: '',
        region: ''
      },
      // 表单验证
      rules: {
        name: [
          { required: true, message: '请输入用户名称', trigger: 'blur' },
          { min: 1, max: 16, message: '长度在 1 到 16 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 3, max: 8, message: '密码长度在 3 到 8 个字符', trigger: 'blur' }
        ],
        region: [
          { required: true, message: '请选择景区', trigger: 'change' }
        ],
      },
      tableData: [],
      currentPage: 1,   //分页
      total: 0,        //分页
      scenicSpotList: [],    //获取景区的数组
      ids: []
    }
  },
  methods: {
    // 点击新增按钮显示弹框
    newlyAdded () {
      this.dialogVisible = true
    },
    // 点击叉号关闭弹框
    handleClose () {
      this.dialogVisible = false
      this.editdialogVisible = false
    },
    // 立即添加按钮
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var that = this
          var userData = qs.parse(sessionStorage.getItem("userData"));
          console.log(userData.id, 1231)
          var salesInfoData = {
            id: userData.id,
            admin: this.ruleForm.name,
            password: this.ruleForm.password,
            area_id: this.ids
          };
          var salesInfoParams = {
            methodUrl: "/admin/addAdminInfo",
            jsonParam: qs.stringify(salesInfoData)
          };
          this.$axios.postRequest(salesInfoParams).then(
            function (res) {
              // 成功后的处理
              if (res.code == 0) {
                that.dialogVisible = false
                that.$refs['ruleForm'].resetFields();
                that.$message({
                  message: '新增成功',
                  type: 'success'
                });
                that.findScenicSpot();
                that.$refs[formName].resetFields();
              } else {
                that.$message.error(res.msg);
              }
            }
          )
        } else {
          console.log('error submit!!');
          return false;
        }

      });
    },
    // 重置按钮
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    // 景区的单选
    radioList (row) {
      var ids = ''
      ids = row
      console.log(ids, 66666)
      this.ids = ids
    },
    //选择景区的复选框
    // choice (row) {
    //   var that = this
    //   var ids = ''
    //   console.log(row, 11112)
    //   row.forEach(item => {
    //     console.log(item.ids + '#', 11111)
    //     if (ids == '') {
    //       ids = item.ids
    //     } else {
    //       ids = ids + '#' + item.ids
    //     }
    //     console.log(ids)
    //   });
    //   this.ids = ids
    // },
    // 获取景区列表
    findScenicSpotList () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        pageindex: 1,
        pagesize: 9999
      };
      var salesInfoParams = {
        methodUrl: "/admin/getScenicArea",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          // that.total = res.data.totalcount;

          res.data.list.forEach(item => {
            var nameList = {}
            var name = ''
            var ids = 0
            // console.log(item.area_name)
            // console.log(item.area_id)
            nameList.name = item.area_name
            nameList.ids = item.area_id
            // console.log(nameList)
            that.scenicSpotList.push(nameList)
            // console.log(that.scenicSpotList)
          });

        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 查询用户列表
    findScenicSpot () {
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var packageList = []
      var salesInfoData = {
        count: true,
        pageindex: this.currentPage,
        pagesize: 10
      };
      var salesInfoParams = {
        methodUrl: "/admin/getAreaAccount",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          that.tableData = res.data.list;
          that.total = res.data.totalcount;
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 表格----修改按钮   
    handleEdit (index, row) {
      console.log(row, 1211)
      this.editdialogVisible = true
      this.editInfo = row
    },
    // 点击修改按钮发送修改请求
    submitFormedit () {
      // console.log(row, 10)
      // console.log(index, row);
      this.editdialogVisible = false
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        lx: 1,
        admin: this.editInfo.admin,
        area_id: this.ids,
        id: this.editInfo.id
      };
      var salesInfoParams = {
        methodUrl: "/admin/updateAreaAccount",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          // that.tableData = res.data.list;
          // that.total = res.data.totalcount;
          that.findScenicSpot()
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 点击取消按钮不显示弹框
    resetFormedit () {
      this.editdialogVisible = false
    },
    // 表格----删除按钮
    handleDelete (index, row) {
      // console.log(index, row);
      var userData = qs.parse(sessionStorage.getItem("userData"));
      var that = this;
      var salesInfoData = {
        lx: 2.,
        admin: row.admin,
        area_id: row.area_id,
        id: row.id
      };
      var salesInfoParams = {
        methodUrl: "/admin/updateAreaAccount",
        jsonParam: qs.stringify(salesInfoData)
      };
      this.$axios.postRequest(salesInfoParams).then(
        function (res) {
          //成功之后处理逻辑
          // that.tableData = res.data.list;
          // that.total = res.data.totalcount;
        },
        function (res) {
          //失败之后处理逻辑
          console.log("error:");
        }
      );
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val;
      this.findScenicSpot();
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      this.findScenicSpot();
    },
  },
  mounted () {
    this.findScenicSpot()
    this.findScenicSpotList()
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/AccountList.vue